// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__20VG2","gfeWrapper":"CalendarEvent_gfeWrapper__2beSi"};